module.exports = __webpack_public_path__ + "static/img/3.1267787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/3.png
// module id = FvLI
// module chunks = 0